import {AfterViewInit, Directive, ElementRef, Input, Renderer2} from '@angular/core';

import {HandlePropChanges} from '../shared';

@Directive({
  selector: 'i[mz-icon], i[mzIcon]',
})
export class MzIconDirective extends HandlePropChanges implements AfterViewInit {
  @Input() align: string;
  @Input() icon: string;
  @Input() size: string;

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {
    super();
  }

  ngAfterViewInit() {
    this.initHandlers();
    this.initMaterialize();
    super.executePropHandlers();
  }

  initHandlers() {
    this.handlers = {
      align: (previousValue) => this.handleAlign(previousValue),
      icon: () => this.handleIcon(),
      size: (previousValue) => this.handleSize(previousValue),
    };
  }

  initMaterialize() {
    this.renderer.addClass(this.elementRef.nativeElement, 'material-icons');
  }

  handleAlign(previousValue?: string) {
    if (previousValue) {
      this.renderer.removeClass(this.elementRef.nativeElement, previousValue);
    }
    if (this.align) {
      this.renderer.addClass(this.elementRef.nativeElement, this.align);
    }
  }

  handleIcon() {
    this.renderer.setProperty(this.elementRef.nativeElement, 'innerHTML', this.icon);
  }

  handleSize(previousValue?: string) {
    if (previousValue) {
      this.renderer.removeClass(this.elementRef.nativeElement, previousValue);
    }
    if (this.size) {
      this.renderer.addClass(this.elementRef.nativeElement, this.size);
    }
  }
}
